/**
 * Redux reducer for running orders.
 * @module redux/reducers/runningOrder
 */

import {
  REQUEST_RUNNING_ORDER,
  RUNNING_ORDER_REQUEST_FAILED,
  RUNNING_ORDER_RECEIVED,
  REQUEST_RUNNING_ORDERS_LIST,
  RUNNING_ORDERS_LIST_REQUEST_FAILED,
  RUNNING_ORDERS_LIST_RECEIVED,
  SELECT_STORY
} from './../actions/runningOrder';

/**
 * @typedef {Object} RunningOrderState
 * @property {Array} runningOrdersList List of rundowns.
 * @property {boolean} runningOrdersListLoading True while the server handlesd the request.
 * @property {Array} runningOrder List of stories in the running order.
 * @property {boolean} runningOrderLoading True while the server handlesd the request.
 * @property {string} selectedStoryId Id of the currently selected story.
 */
const initialState = {
  runningOrdersList: [],
  runningOrdersListLoading: false,
  runningOrder: {},
  runningOrderLoading: false,
  selectedStoryId: ''
};

const ACTION_HANDLERS = {
  [REQUEST_RUNNING_ORDERS_LIST]: state => ({
    ...state,
    runningOrdersListLoading: true
  }),
  [RUNNING_ORDERS_LIST_REQUEST_FAILED]: state => ({
    ...state,
    runningOrdersListLoading: false
  }),
  [RUNNING_ORDERS_LIST_RECEIVED]: (state, action) => {
    const updatedState = {
      ...state,
      runningOrdersList: action.payload.runningOrdersList,
      runningOrdersListLoading: false
    };
    if (
      state.runningOrder.id &&
      !action.payload.runningOrdersList.some(ro => ro.id === state.runningOrder.id)
    ) {
      return {
        ...updatedState,
        runningOrder: {},
        selectedStoryId: ''
      };
    }
    return updatedState;
  },
  [REQUEST_RUNNING_ORDER]: state => ({
    ...state,
    runningOrderLoading: true
  }),
  [RUNNING_ORDER_REQUEST_FAILED]: state => ({
    ...state,
    runningOrderLoading: false
  }),
  [RUNNING_ORDER_RECEIVED]: (state, action) => ({
    ...state,
    runningOrder: action.payload.runningOrder,
    runningOrderLoading: false
  }),
  [SELECT_STORY]: (state, action) => ({
    ...state,
    selectedStoryId: action.payload.selectedStoryId
  })
};

export default function runningOrder(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/runningOrder.js